<h3 mat-dialog-title class="v2-title">
    <span>{{ 'Let\'s configure and verify your Stripe account to process online payments.' }}</span>
    <button mat-icon-button [disableRipple]="true" class="v2-close" (click)="close()" aria-label="close">
        <mat-icon>close</mat-icon>
    </button>
</h3>

<mat-dialog-content>
    <app-onboarding-intro-content
        [useNewStyles]="false"
        (startVerification)="startVerification()"></app-onboarding-intro-content>
</mat-dialog-content>
